import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

import useScreenWidth from "../../hooks/useScreenWidth.js";
import Footer from "../../components/footer/Footer.jsx";
import NoAccess from "../../components/no_access/NoAccessAlertController.jsx";
import { GlobalContext } from "../../globals/globalContext.jsx";
import CartHeader from "../cart-header/CartHeader.jsx";
import CatalogItemList from "../catalog-item-list/CatalogItemList.jsx";
import "./styles.styl";
import LabeledPrice from "../../components/labeled-price/LabeledPrice";
import Button from "../../components/button/ButtonController";
import Settings from "../../components/settings/SettingsController.jsx";
import OrderingInfo from "../cart-item/OrderingInfo";
import { CartTop } from "../cart/CartTop/CartTop";
import { Context as LoginContext } from "../../components/login/LoginController";
import LoadingSpinner from "../../atoms/loadingSpinner/LoadingSpinner.jsx";
import { useIntl, FormattedMessage } from "react-intl";
import ShoppingCart from "jsx:../../assets/svgs/shopping_cart.svg";
import DownArrow from "jsx:../../assets/svgs/down-arrow.svg";

const styles = {
  colorPrimary: "",
  colorSecondary: "",
  logoSmallUrl: "",
};

export default function ShopPage(props) {
  const {
    activeSearch,
    setActiveSearch,
    browser_is_IE,
    showSettings,
    onTopClick,
    onSettingsClose,
    onSettingsChange,
    gmbhName,
    logoBigUrl,
    logoFavIcon,
    logoSmallUrl,
    phoneNumber,
    companyEmail,
    companyAddress,
    colorPrimary,
    colorSecondary,
    homePage,
    webhost,
    bioCertification,
    taxDetails,
    privacyPage,
    conditionsPage,
    companyName,
    productType,
    filteredProductType,
    fetchCatalog,
    setFilteredProductType,
    catalogLoaded,
    footerTextInShop,
    defaultCommercialCustomers,
    isStaff,
    searchText,
    search,
    isCatalogEmpty,
    productsByCategory,
    filteredProductsByCategory,
    categories,
  } = props;
  const intl = useIntl();
  const windowWidth = useScreenWidth();
  const [activeTabIndex, setActiveTabIndex] = useState();
  const [fromFooter, setFromFooter] = useState();
  const stickyPaymentContainerRef = useRef(null);
  const cartRowRef = useRef(null);
  const cardHeaderRef = useRef(null);
  const incl_excl = defaultCommercialCustomers
    ? intl.formatMessage({ id: "exclusive" })
    : intl.formatMessage({ id: "inclusive" });
  const [dialogOpen, setDialogOpen] = useState(false);
  const { isAuthenticated } = useContext(LoginContext);
  const isMobile = windowWidth < 940;

  const {
    is_shipping, // TODO: FIGURE OUT IF THIS IS NEEDED
  } = {};

  const dialogRef = useRef(null);
  const showOnboardingPopup = (payload) => {
    if (isStaff) {
      window.location.href = "/";
      return;
    }
    if (payload?.deliver_listing) {
      localStorage.setItem("toBeAddedCartItemId", JSON.stringify(payload));
    }
    setDialogOpen(true);
  };
  const closePopup = () => {
    setDialogOpen(false);

    if (dialogRef.current) {
      dialogRef.current.close();
    }
  };

  const closeSettingsAndconfigureActiveTab = async (
    tabIndex,
    fromFooter = false,
  ) => {
    onSettingsClose();
    setFromFooter(fromFooter);
    setActiveTabIndex(tabIndex);
  };
  const openSettingsOrTab = (tabIndex, fromFooter = false) => {
    closeSettingsAndconfigureActiveTab(tabIndex, fromFooter).then(() => {
      onTopClick();
    });
  };

  useEffect(() => {
    const handlePopState = () => {
      window.location.reload();
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    search(searchText);
    styles.colorPrimary = colorPrimary;
    styles.colorSecondary = colorSecondary;
    styles.logoSmallUrl = logoSmallUrl;
  }, [props.reRender]);

  useEffect(() => {
    if (dialogOpen && dialogRef.current) {
      dialogRef.current.style.width = "90%";
      dialogRef.current.style.height = "90%";
      dialogRef.current.style.maxWidth = "800px";
      dialogRef.current.style.maxHeight = "600px";

      dialogRef.current.showModal();

      const iframe = dialogRef.current.querySelector("iframe");
      if (iframe) {
        iframe.onload = function () {
          iframe.contentWindow.postMessage({ type: "insideDialog" }, "*");
        };
      }
    }
  }, [dialogOpen]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === "formSubmitted") {
        closePopup();
        window.location.href = event.data.deliveryUrl;
      } else if (event.data.type === "closeDialogAndRedirect") {
        closePopup();
        window.location.href = event.data.url;
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    if (isAuthenticated && !isStaff) {
      window.location.href = "/";
    }
  }, [isAuthenticated, isStaff]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleDownArrowClick = () => {
    const categoryElement = document.querySelector(".categorNavItem__title");
    if (categoryElement) {
      categoryElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="cart shop">
      {dialogOpen && (
        <>
          <div className="dialog-overlay"></div>
          <dialog
            ref={dialogRef}
            style={{
              padding: "0",
              borderRadius: "8px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              border: "none",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="dialog-close-button" onClick={closePopup}>
              &times;
            </button>
            <iframe
              src="/email-delivery/"
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          </dialog>
        </>
      )}
      <GlobalContext.Provider
        value={{
          activeSearch,
          setActiveSearch,
          reRender: props.reRender,
          setRender: props.setRender,
          gmbhName,
          logoBigUrl,
          logoFavIcon,
          logoSmallUrl,
          phoneNumber,
          companyEmail,
          companyAddress,
          onFavouriteAddRemove: showOnboardingPopup,
          ownerlessShop: true,
          colorPrimary,
          colorSecondary,
          homePage,
          bioCertification,
          taxDetails,
          privacyPage,
          conditionsPage,
          webhost,
          companyName,
          productType,
          filteredProductType,
          fetchCatalog,
          setFilteredProductType,
          catalogLoaded,
          windowWidth,
          isMobile,
        }}
      >
        {browser_is_IE && <BrowserWarning />}
        {showSettings && (
          <Settings
            onClose={onSettingsClose}
            onChange={onSettingsChange}
            is_shipping={is_shipping}
            logoSmallUrl={logoSmallUrl}
            conditionsPage={conditionsPage}
            phoneNumber={phoneNumber}
            companyEmail={companyEmail}
            webhost={webhost}
            catalogLoaded={catalogLoaded}
            activeTabIndex={activeTabIndex}
            setActiveTabIndex={setActiveTabIndex}
            fromFooter={fromFooter}
            setFromFooter={setFromFooter}
            companyAddress={companyAddress}
            bioCertification={bioCertification}
            taxDetails={taxDetails}
            privacyPage={privacyPage}
            homePage={homePage}
            visitedFromCart={false}
          />
        )}
        <CartTop
          homePage={homePage}
          openSettingsOrTab={() => (window.location.href = "/")}
          companyName={companyName}
          logoSmallUrl={logoSmallUrl}
        />

        <div className="cart__row-responsive" ref={cartRowRef}>
          <div className="cart__row overview cart__row-car-checkout">
            <div ref={cardHeaderRef}>
              <div className="setting-banner-wrapper">
                <div className="cart__down-arrow-wrapper">
                  <DownArrow
                    className="cart__down-arrow"
                    onClick={handleDownArrowClick}
                  />
                </div>
                <div className="settings-tabs__head">
                  {intl.formatMessage({ id: "cart" })}
                </div>
                <ShoppingCart className="cart__basket-shopping-cart" />
              </div>
              <CartHeader
                address={intl.formatMessage({ id: "checkDeliveryArea" })}
                showPreferencesFunc={showOnboardingPopup}
                colorPrimary={colorPrimary}
                cardHeaderRef={cardHeaderRef}
                onClick={showOnboardingPopup}
                onDateClick={showOnboardingPopup}
              />

              <OrderingInfo
                editable={true}
                delivery={undefined}
                allow_ordering_before_suggestions_at={undefined}
                delivery_smartfill_state={undefined}
                delivery_suggestion_state={undefined}
                days_until_ordering_window_opens={undefined}
                empty={false}
                remaining_time={undefined}
                companyEmail={props.companyEmail}
                companyName={props.companyName}
                nextEditableCart={props.nextEditableCart}
                ownerlessShop={true}
                showOnboardingPopup={showOnboardingPopup}
              />
            </div>

            <div className="sticky-container" ref={stickyPaymentContainerRef}>
              <div className="cart-summary__boxprice">
                <div className="cart-summary__total-price">
                  <LabeledPrice
                    label={intl.formatMessage({ id: "totalPrice" })}
                    price="0"
                  />
                </div>
              </div>

              <Button
                onClick={showOnboardingPopup}
                confirm={false}
                label={intl.formatMessage({ id: "order" })}
              />
              <div className="cart-order-bar__message">
                <FormattedMessage
                  id="vatText"
                  values={{ incl_excl: incl_excl }}
                />
              </div>
            </div>
          </div>
          {/* here is the point where the responsive should start */}
          <div className="cart__row cart__catalog">
            <LoadingSpinner
              isLoading={!catalogLoaded}
              clazzName={
                !catalogLoaded
                  ? "cart-wrapper__spinner"
                  : "cart-wrapper__container"
              }
              applyStylesToMain={true}
            >
              <CatalogItemList
                search={search}
                searchText={searchText}
                isGrid={true}
                ownerlessShop={true}
                isCatalogEmpty={isCatalogEmpty}
                isFilteredProduct={searchText !== ""}
                allow_ordering_before_suggestions_at={true}
                onChange={showOnboardingPopup}
                productsByCategory={
                  searchText !== ""
                    ? filteredProductsByCategory
                    : productsByCategory
                }
                categories={categories}
                footerTextInShop={footerTextInShop}
                onFavouriteAddRemove={showOnboardingPopup}
                reRender={() => {
                  props.setRender(!props.reRender);
                }}
              />
            </LoadingSpinner>
          </div>
        </div>
        <Footer
          currentLang={intl.locale}
          onFooterLinkClick={openSettingsOrTab}
        ></Footer>
      </GlobalContext.Provider>
    </div>
  );
}

function BrowserWarning(props) {
  return (
    <>
      <NoAccess
        colorSecondary={styles.colorSecondary}
        logoSmallUrl={styles.logoSmallUrl}
      >
        <FormattedMessage id="useDifferentBrowser" />
      </NoAccess>
    </>
  );
}
